<template>
  <v-container fluid>
    <div class="main">

      <v-row>
        <v-col cols="12">
          <v-tabs v-model="tab" color="gifty" background-color="transparent">
            <v-tab tab-value="4g" @click="[tab = '4g' ,fetchData()]">Stock Catres 4G</v-tab>
            <v-tab tab-value="idoom" @click="[tab = 'idoom' ,fetchData()]">Stock Catres idoom</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row v-if="isLoading">
        <v-col cols="12">
          <v-card class="rounded-lg" flat>
            <v-skeleton-loader type="table"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12">
          <v-card class="rounded-lg" flat>

            <v-card-title>
              <div>
                <v-text-field
                    v-model="keyword"
                    rounded
                    filled
                    dense
                    :style="{width: '300px'}"
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                    clearable
                    placeholder="Rechercher..."
                    v-on:keyup.enter="fetchData"
                />
              </div>
              <v-spacer/>
              <v-btn color="gifty" text @click="fetchData">
                <v-icon left>mdi-refresh</v-icon>
                Mettre à jour
              </v-btn>
            </v-card-title>

            <v-divider/>

            <v-card-text>
              <v-data-table
                  class="table-border rounded-lg"
                  :items="stocks"
                  :headers="headers"
              >
                <template #item.type="{ item }">
                  <v-chip color="gifty" dark label small>
                    <v-icon left small>mdi-tag-outline</v-icon>
                    {{ item.type }}
                  </v-chip>
                </template>
                <template #item.total_restante="{ item }">
                  <div class="text-no-wrap font-weight-bold"
                       :class="item.total_restante === 0 ? 'red white--text' : ''">
                    {{ CurrencyFormatting(item.total_restante) }} DZD
                  </div>
                </template>
                <template #item.amount="{ item }">
                  <div class="font-weight-bold gifty-text text-no-wrap">
                    {{ CurrencyFormatting(item.amount) }} DZD
                  </div>
                </template>

                <template #item.total_consume="{ item }">
                  <div class="font-weight-bold red--text text-no-wrap">
                    {{ CurrencyFormatting(item.total_consume) }} DZD
                  </div>
                </template>

                <template v-slot:body.append>
                  <tr class="font-weight-bold" :style="{background: 'rgba(214,12,86,0.08)'}">
                    <td>Total</td>
                    <td></td>
                    <td>
                      {{ totalQuantityRestante }}
                    </td>
                    <td :class="totalRestante === 0 ? 'red white--text' : ''">
                      {{ CurrencyFormatting(totalRestante) }} DZD
                    </td>
                    <td>
                      {{ totalQuantityConsume }}
                    </td>
                    <td class="red--text">
                      {{ CurrencyFormatting(totalConsume) }} DZD
                    </td>
                  </tr>
                </template>


              </v-data-table>

            </v-card-text>

          </v-card>
        </v-col>
      </v-row>
    </div>


  </v-container>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      tab: "4g",
      keyword: null,
      isLoading: false,
      stocks: [],
      headers: [
        {text: "Type", value: "type"},
        {text: "Prix", value: "amount"},
        {text: "Quantité restante", value: "quantity_restante"},
        {text: "Total restant", value: "total_restante"},
        {text: "Quantité consommée", value: "quantity_consume"},
        {text: "Total consommé", value: "total_consume"},
      ]
    };
  },
  methods: {
    fetchData() {
      this.isLoading = true;
      HTTP.get("cards/list/stock", {
        params: {
          keyword: this.keyword,
          type: this.tab,
        }
      }).then((res) => {
        this.isLoading = false;
        this.stocks = res.data.data;
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      })
    }
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    totalRestante() {
      return this.stocks.reduce((sum, item) => sum + (item.total_restante || 0), 0);
    },
    totalConsume() {
      return this.stocks.reduce((sum, item) => sum + (item.total_consume || 0), 0);
    },
    totalQuantityRestante() {
      return this.stocks.reduce((sum, item) => sum + (item.quantity_restante || 0), 0);
    },
    totalQuantityConsume() {
      return this.stocks.reduce((sum, item) => sum + (item.quantity_consume || 0), 0);
    },
  },
};
</script>

<style scoped>

</style>